import React from 'react';
import cx from 'classnames';

import Button from '~/components/button';
import { ReviewsElement } from '~/components/static/reviews/reviews-elements';
import { toLongFullDateString } from '~/utils/dates';

import styles from '~/components/plans/bundles-page/plan-bundle-page.module.scss';

const PurchaseCta = ({
  mainContent, // Instance of <PlanDescription>
  disclaimerText,
  priceComponent, // Instance of <PurchaseCtaPrice>
  tagline,
  buttonText,
  onClick,
  isLoading,
  showReviews,
  reviewsLinkAnchor,
  firstShipmentDate,
}) => {
  return (
    <div
      className={cx('panel', styles.purchaseCta)}
      id="lawn-plan-footer-purchase-cta"
    >
      <div className={styles.purchaseCtaMainContent}>{mainContent}</div>
      <div>
        <p className={styles.purchaseCtaPrice}>{priceComponent}</p>

        {tagline && <p className={styles.purchaseCtaTagline}>{tagline}</p>}

        <Button
          fullWidthMobile
          onClick={onClick}
          isLoading={isLoading}
          className={styles.purchaseCtaButton}
        >
          {buttonText}
        </Button>

        {firstShipmentDate && (
          <p className={styles.expectedShipDate}>
            Ships on {toLongFullDateString(firstShipmentDate)}.
          </p>
        )}

        {showReviews && (
          <div className={styles.purchaseCtaReviewsContainer}>
            <ReviewsElement linkAnchor={reviewsLinkAnchor} variant="dark" />
          </div>
        )}

        <p className={styles.purchaseCtaDisclaimer}>{disclaimerText}</p>
      </div>
    </div>
  );
};

export default PurchaseCta;
